import { formatDateToYYYYMMDDhhmm } from "@/common/util/date-util";
import { OrderDetailDto } from "@/types/dto/order-detail-dto";
import { Body14Regular } from "../typography/Body14Regular";
import { H4 } from "../typography/H4";

interface Props {
  orderDetail: OrderDetailDto;
}

export const PartnerOrderDetailHeader: React.FC<Props> = ({ orderDetail }) => {
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between h-[50px] mb-[12px]">
        <div className="mt-[15px] mb-[7px] flex ">
          <H4 className="text-semantic-text-heading">발주서 상세 정보</H4>
          <div className="flex py-[3px] gap-[12px] ml-[12px]">
            <Body14Regular className="text-semantic-text-secondary">
              {`발주일자: ${formatDateToYYYYMMDDhhmm(orderDetail.createdAt)}`}
            </Body14Regular>
            <Body14Regular className="text-semantic-text-secondary">
              {`발주번호: ${orderDetail.invoiceNumber}`}
            </Body14Regular>
          </div>
        </div>
        <div />
      </div>
    </div>
  );
};
